export default {
    name: 'SignOutButton',

    methods: {
        signout() {
            this.$ionic.alertController.create({
                message: "Are you sure you want to sign out? You will need to be connected to the Internet to sign back in.",
                buttons: [
                    {
                        text: 'Sign Out',
                        role: 'signout',
                        handler: () => {
                            this.$store.dispatch('clearData').then(() => {
                                this.$router.push({ path: '/' });
                            });
                        },
                    },
                    {
                        text: 'Cancel',
                    },
                ],
            }).then(a => a.present());
        }
    }
};